import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Divider } from 'antd';
import styled from 'styled-components';

import { isEmpty, map } from '../../../util/lodashlike';
const DividerColumn = styled(Col)`
  text-align: center;
`;

const DividerWrapper = styled(Divider)`
  height: 100%;
  margin: 0;
  border-color: #4d7195;
  opacity: 0.5;
`;

const PartySectionItems = ({
  source = [],
  colSpan = 6,
  showDivider = false
}) => (
  <>
    <Col span={showDivider ? colSpan - 1 : colSpan}>
      {!isEmpty(source) && (
        <Row gutter={[5, 10]}>
          {map(
            source,
            ({ component: Component, ...reset }, idx) =>
              Component && (
                <Component {...reset} key={`party_section_item_${idx}`} />
              )
          )}
        </Row>
      )}
    </Col>
    {showDivider && (
      <DividerColumn span={1}>
        <DividerWrapper type="vertical" />
      </DividerColumn>
    )}
  </>
);

PartySectionItems.prototype = {
  source: PropTypes.array,
  colSpan: PropTypes.number,
  showDivider: PropTypes.bool
};

export default PartySectionItems;
